import React from "react";

export default props => {
  return (
    // <div className="d-flex justify-content-center">
    <div className="spinner spinner-round"></div>
    // </div>
  );
};
